import $ from 'jquery';
import { Fancybox } from "@fancyapps/ui";

const fancybox = () => {

	Fancybox.bind('.fancybox', {
		tpl: {
			// next: '<a class="fancybox-nav fancybox-next" href="javascript:;"><span class="icon icon--arrow-right-small"></span></a>',
			// prev: '<a class="fancybox-nav fancybox-prev" href="javascript:;"><span class="icon icon--arrow-left-small"></span></a>',
			closeBtn: '<a class="fancybox-item fancybox-close" href="javascript:;"><span class="icon icon--cross"></span></a>'
		},
		helpers : {
			title : {
				type : 'inside'
			}
		},
		afterShow: function(obj){
			var $target = $('.b-fancybox');
			$target.trigger('contentload');

			// rezervace zarizeni nebo objednavka prohlidky - dosazeni informaci o produktu
			if ( this.href == '#fancybox-rezervace' || this.href == '#fancybox-prohlidka' || this.href == '#fancybox-services' ) {
				$(this.href).find('a').attr('href', $(this.element).data('product-url'));
				$(this.href).find('.b-product__img').html('<img src="' + $(this.element).data('product-image') + '" width="50" height="50" alt="Product">');
				$(this.href).find('.b-product__name').html($(this.element).data('product-name'));
				$(this.href).find('.b-product__desc').html('<strong>' + skwp.message_product_sku + '</strong> - ' + $(this.element).data('product-sku'));

				$(this.href).find('#form_product_name').val($(this.element).data('product-name'));
				$(this.href).find('#form_product_sku').val($(this.element).data('product-sku'));
				$(this.href).find('#form_product_url').val($(this.element).data('product-url'));
				$(this.href).find('#form_product_id').val($(this.element).data('product-id'));
			}
		}
	});

};

exports.init = fancybox;



// WEBPACK FOOTER //
// ./src/js/components/fancybox.js